/**
 * @fileoverview POST handler for the "/engagement/report_builder_2/:app_group_id/clone" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementReportBuilder2CloneCacheKeys } from "./constants";
import type { PostEngagementReportBuilder2CloneProps, ReportBuilder2CloneResult } from "./types";

export const postEngagementReportBuilder2Clone = reactQueryMutationAdapter(
  engagementReportBuilder2CloneCacheKeys,
  (props: PostEngagementReportBuilder2CloneProps): Promise<ReportBuilder2CloneResult> => {
    return fetch(`/engagement/report_builder_2/${props.app_group_id}/clone`, "POST", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
